<script>
  import { createEventDispatcher } from 'svelte';
  export let message = '';
  export let titulo = 'Aviso';
  export let button1Label = 'Ok';
  export let button2Label = '';
  export let button3Label = '';
  export let button1Action = () => {};
  export let button2Action = () => {};
  export let button3Action = () => {};

  const dispatch = createEventDispatcher();

  function fechar() { dispatch('close'); message = ''; }
</script>

{#if message}
  <div class="overlay">
    <div class="caixa">
      <h6 class="titulo">{titulo}</h6>
      <p>{@html message}</p>
      <div class="botoes">
        {#if button3Label}
          <button class="btn btn-primary btn-sm" on:click={() => { button3Action(); fechar(); }}>{button3Label}</button>
        {/if}
        {#if button2Label}
          <button class="btn btn-secondary btn-sm" on:click={() => { button2Action(); fechar(); }}>{button2Label}</button>
        {/if}
        <button class="btn btn-outline-secondary btn-sm" on:click={() => { button1Action(); fechar(); }}>{button1Label}</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,0.45);
    display: flex; align-items: center; justify-content: center; z-index: 9999;
  }
  .caixa {
    background: #fff; border-radius: 10px; padding: 24px 28px;
    max-width: 420px; width: 90%; box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  }
  .titulo { font-weight: bold; margin-bottom: 12px; }
  .botoes { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }

  @media (max-width: 640px) {
    .caixa {
      padding: 20px 18px;
      border-radius: 12px;
    }

    .botoes {
      flex-direction: column-reverse;
    }

    .botoes button {
      width: 100%;
    }
  }
</style>
